import { Cookies } from '../cookies';

type GlobalECookieParamType = {
  locale?: string;
  guid?: string;
};
export const addGlobalECookie = ({ locale = '', guid }: GlobalECookieParamType) => {
  const [, country] = locale.split('-');
  if (locale && country && guid) {
    const countryCap = country.toUpperCase();
    const params = {
      country: countryCap,
      locale,
      token: guid,
    };
    const existingCookie = Cookies.get('globale-params');
    if (
      !existingCookie ||
      existingCookie.country !== countryCap ||
      existingCookie.locale !== locale ||
      existingCookie.token !== guid
    ) {
      Cookies.set('globale-params', params, {
        path: '/',
        secure: true,
      });
    }
  }
};
